import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=1573944e&scoped=true"
import script from "./DatePicker.ts?vue&type=script&lang=ts&external"
export * from "./DatePicker.ts?vue&type=script&lang=ts&external"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=1573944e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1573944e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1573944e')) {
      api.createRecord('1573944e', component.options)
    } else {
      api.reload('1573944e', component.options)
    }
    module.hot.accept("./DatePicker.vue?vue&type=template&id=1573944e&scoped=true", function () {
      api.rerender('1573944e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Holidays/components/DatePicker/DatePicker.vue"
export default component.exports